import React, { useState, useEffect } from 'react';
import {
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
  Modal,
  ModalHeader
} from 'reactstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import cellEditFactory from 'react-bootstrap-table2-editor'
import withReactContent from 'sweetalert2-react-content'
import AsyncSelect from 'react-select/async'
import NumberFormat from 'react-number-format'
import Switch from 'react-switch'

import ReactSelect from 'components/Form/Select/Select'
import rotas from 'services/rotas'
import rest from 'lib/rest'
import Swal from 'sweetalert2'
import Loading from 'lib/loading'
import useForm from 'lib/useForm'
import './style.css'
import DuplicaKit from './DuplicaKit'
import useToggle from 'lib/useToggle'

const formSwal = withReactContent(Swal)

const FormKit = ({fechaModal, kit_id, setKit_id}) => {

  const initialFormKit = {
    kit_ativo: "S",
    kit_id: "",
    kit_nome: "",
    kit_saldo: 0
  }

  const initialFormProd = {
    produto_id: "",
    quantidade: 0,
    valor:      "",
    desconto:   "",
    total:      "",
  }

  const colunas = [
    {
      dataField: 'produto_id',
      text: 'Código',
      editable: false,
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'produto',
      text: 'Produto',
      editable: false,
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'prod_saldo',
      text: 'Saldo atual',
      editable: false,
      headerStyle: { cursor: 'default'},
      formatter: (cellContent, row) => {return (parseInt(cellContent))}
    },
    {
      dataField: 'quantidade',
      text: 'Quantidade',
      type: "number",
      headerStyle: { cursor: 'pointer' },
      formatter: (cellContent, row) => {return (parseInt(cellContent))}
    },
    {
      dataField: 'valor',
      text: 'Valor no Kit',
      type: "number",
      headerStyle: { cursor: 'pointer' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))}
    },
    {
      dataField: 'total',
      text: 'total',
      editable: false,
      headerStyle: { cursor: 'default' },
      formatter: (cellContent, row) => {return (parseFloat(cellContent).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))}
    },
    {
      dataField: 'ativo',
      text: 'Ativo',
      align: 'center',
      editable: false,
      headerStyle: { cursor: 'pointer' },
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => { desativarProduto(row) },
      },
      formatter: (cellContent, row) => {
        return (
          <>
            <Switch
              id        = {row.produto_id}
              className = "react-switch"  
              height    = {15}
              width     = {35}
              onColor   = '#6bd098'
              checked   = {row.ativo === 'S' ? true : false}
              onChange  = {(e)=>{}}
            />
          </>
        );
      },
    }
  ]

  const [form, onChange, setForm]               = useForm(initialFormKit)
  const [formProd, onChangeProd, setFormProd]   = useForm(initialFormProd)
  const [loading, setLoading]                   = useState(true)
  const [loadingListProd, setLoadingListProd]   = useState(false)
  const [activeTab, setActiveTab]               = useState('1')
  const [listaLoja, setListaLoja]               = useState([])
  const [filial, setFilial]                     = useState(null)
  const [listaProdutosKit, setListaProdutosKit] = useState([])
  const [valorProdutosKit, setValorProdutosKit] = useState('R$ 0,00')
  const [camposProduto, setCamposProduto]       = useState(true)
  const [produtoSaldo, setProdutoSaldo]         = useState(true)
  const [duplicarKitBtn, setDuplicarKitBtn]     = useState(true)
  const [modalDuplicaKit, setModalDuplicaKit]   = useToggle(false);

  const clickProdutoSaldo = () => setProdutoSaldo(!produtoSaldo)

  const listarKitCampanha = () => {
    if (kit_id !== '') {
      const url     = rotas.Kit;
      const retorno = rest.get(url + 'edit.php?kit_id=' + kit_id)

      retorno.then(ret => {
        if (ret.success && ret.success == 'S'){
          let lista = ret.lista
          setForm(lista)
          // setForm({...form, ['kit_id']: lista.kit_id, ['kit_nome']: lista.kit_nome, ['kit_saldo']: lista.kit_saldo, ['kit_ativo']: lista.kit_ativo})
        }
        setLoading(false)
      })
    }else{
      setLoading(false)
    }
  }

  const listaLojas = () => {
    let lista = []
    try{
      const retorno = rest.get(rotas.lojas)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          for (let i = 0; i < ret.lista.length; i++) {
            lista[i] = {"id":ret.lista[i].filial_id, "title":ret.lista[i].cnpj +" - "+ ret.lista[i].fantasia}
          }
          setListaLoja(lista)
        }else{
          setListaLoja([])
        }
        setLoading(false)
      })
      return (lista)
    }catch(err){
      setLoading(false)
    }
  }

  const selectFilial = (e) => {
    setFormProd(initialFormProd)
    setFilial(e)
    setDuplicarKitBtn(false)
  }

  const listaProdtudosKit = () => {
    setLoadingListProd(true)
    try{
      const retorno = rest.get(rotas.Kit + 'listaProdutosKit.php?kit_id='+ kit_id +'&filial_id=' + filial.id)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){

          setListaProdutosKit(ret.lista)
          setValorProdutosKit(parseFloat(ret.valorTotal).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))
        }else{
          setListaProdutosKit([])
        }
        setLoadingListProd(false)
      })
    }catch(err){
      setListaProdutosKit([])
      setLoadingListProd(false)
    }
  }

  const activeTabProdutos = () => {
    if (kit_id !== '') {
      setActiveTab('2')
    } else {
      formSwal.fire('Atenção', 'Salve o kit antes de acessar a lista de produtos.', 'warning')
    }
  }

  const produtoSelecionado = (selecProduto) => {
    let produto = {
      kit_id : form.kit_id,
      filial_id : filial.id,
      produto_id: selecProduto.value,
      quantidade: 1,
      valor: parseFloat(selecProduto.prvenda),
      desconto: 0.00,
      total: parseFloat(selecProduto.prvenda)
    }

    setFormProd(produto)
  }

  const pesquisaProdutos = (value) => {
    if (value.length > 2) {
      const parametros  = {
              filial_id: filial.id,
              produto: value,
              saldo: produtoSaldo ? 'S' : 'N'
            },
            url         = rotas.Kit+"pesquisaProduto.php",
            retorno     = rest.post(url, parametros)

      return retorno.then(ret => {
        let lista = [];
        ret.lista.map(prod => {
          lista.push({
            label: prod.produto+" ("+prod.fornecedor+")",
            value: prod.produto_id,
            prvenda: prod.prod_prvenda
          })
        })
        return (lista)
      })
    }
  }

  const atualizaValorTotal = () => {

    let novoValor   = formProd.valor.toString().replace(/[^0-9|.|,]/g, ''),
        desconto    = formProd.desconto.toString().replace(/[^0-9|.|,]/g, ''),
        quantidade  = parseInt(formProd.quantidade)

    novoValor = novoValor.replace(',', '.')
    novoValor = (novoValor - ((novoValor * desconto) / 100)) * quantidade

    setFormProd({ ...formProd, ['total']: novoValor});
  }

  const handleSubmit = (evt) => {
    evt.preventDefault()

    formSwal.queue([{
      title: 'Deseja salvar ?',
      confirmButtonText: 'Salvar',
      showCancelButton: true,
      text:'Essas informações serão salvas no banco',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: () => {
        const url = rotas.Kit+'gravar.php'

        if(kit_id !== ''){
          return rest.post(url, form)
          .then(ret => {

            if (ret.success && ret.success == 'S') {
              listarKitCampanha(kit_id)
              formSwal.fire('Salvo!', ret.msg, 'success')
            }else{
              formSwal.fire('Erro!', ret.msg, 'error')
            }
          })

        }else{
          return rest.put(url, form)
          .then(ret => {

            if (ret.success && ret.success == 'S') {
              setKit_id(ret.kit_id)
              setForm({ ...form, ['kit_id']: ret.kit_id});
              listarKitCampanha(ret.kit_id)
              formSwal.fire('Salvo!', ret.msg, 'success')
            }else{
              formSwal.fire('Erro!', ret.msg, 'error')
            }
          })
        }
      }
    }])
  }

  const inserirProduto = () => {

    if (formProd.produto_id != '') {
      formSwal.queue([{
        title: 'Deseja inserir o produto na lista do Kit ?',
        confirmButtonText: 'Inserir',
        showCancelButton: true,
        text:'Essas informações serão salvas no banco',
        showLoaderOnConfirm: true,
        cancelButtonColor: '#d33',
        preConfirm: () => {
          const url = rotas.Kit+'inserirProduto.php'
  
          return rest.put(url, formProd)
          .then(ret => {
  
            if (ret.success && ret.success == 'S') {
              setFormProd(initialFormProd)
              listaProdtudosKit()
              formSwal.fire('Salvo!', ret.msg, 'success')
            }else{
              formSwal.fire('Erro!', ret.msg, 'error')
            }
          })
        }
      }])
    }else{
      formSwal.fire('Produto não selecionado!', 'Por favor, selecione um produto', 'warning')
    }
  }

  const desativarProduto = (row) => {

    let msg = row.ativo == 'S' ? 'desativar' : 'ativar'
    
    formSwal.queue([{
      title: 'Deseja '+msg+' o produto da lista do Kit ?',
      confirmButtonText: msg[0].toUpperCase() + msg.substring(1),
      showCancelButton: true,
      // text:'Essas informações serão salvas no banco',
      input: 'checkbox',
      inputPlaceholder: 'Marque para replicar nas lojas',
      showLoaderOnConfirm: true,
      cancelButtonColor: '#d33',
      preConfirm: (result) => {

        let replicar  = result == 1 ? 'S' : 'N'
        const url     = rotas.Kit+'desatisarProduto.php?replicar='+replicar

        return rest.post(url, row)
        .then(ret => {
          if (ret.success && ret.success == 'S') {
            listaProdtudosKit()
            formSwal.fire('Salvo!', ret.msg, 'success')
          }else{
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        })
      }
    }])
  }

  const listaProdtudosKit2 = () => {
    try{
      const retorno = rest.get(rotas.Kit + 'listaProdutosKit.php?kit_id='+ kit_id +'&filial_id=' + filial.id)
      retorno.then(ret => {
        if (ret.success && ret.success == 'S' && ret.lista != ''){
          setListaProdutosKit(ret.lista)
          setValorProdutosKit(parseFloat(ret.valorTotal).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }))
        }
      })
    }catch(err){
    }
  }

  function  beforeSaveCell ( oldValue, newValue, row, column, done ) {

    if (oldValue != newValue) {
      if (!isNaN(newValue) && newValue > '0') {
        row[column.dataField] = newValue

        const url = rotas.Kit+'gravarProduto.php'
    
        return rest.post(url, row)
        .then(ret => {
          if (ret.success && ret.success == 'S') {
            listaProdtudosKit2()
            formSwal.fire('Salvo!', column.text+' do produto alterado.', 'success')
          }else{
            listaProdtudosKit2()
            formSwal.fire('Erro!', ret.msg, 'error')
          }
        })
      }else{
        listaProdtudosKit2()
      }
    }
  }

  const abreModalDuplicaKit = () => {
    if (listaProdutosKit.length > 0) {
      setModalDuplicaKit()
    }else{
      formSwal.fire('Lista de produtos vazia!', 'Favor, inserir produtos na lista antes de replicar.', 'warning')
    }
  }

  const fechaModalDuplicaKit = () => {
    setModalDuplicaKit()
  }

  useEffect(() => {
    listarKitCampanha();
  }, [])

  useEffect(() => {
    if (activeTab == '2') {
      listaLojas();
    }
  }, [activeTab])

  useEffect(() => {
    if (activeTab == '2') {
      listaProdtudosKit();
      if (filial) {
        setCamposProduto(false)
      }
    }
  }, [filial])

  if (loading) {
    return (
      <ModalBody className="loadingBody">
        <Loading tipo='componente'/>
      </ModalBody>
    )
  }
  return (
    <>
      <FormGroup className="formCadastro">
        <ModalBody className="pb-0">

          <Nav pills className="nav-pills-default justify-content-center mb-3">
            <NavItem>
              <NavLink
                className = {activeTab == '1' ? 'active' : ''}
                onClick   = {() => setActiveTab('1')}
              >
                Dados do Kit
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className = {activeTab == '2' ? 'active' : ''}
                onClick   = {() => activeTabProdutos()}
              >
                Lista de Produtos
              </NavLink>
            </NavItem>
          </Nav>

          <hr />

          <TabContent activeTab={activeTab}>
            <TabPane tabId="1">

              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md='3'>
                    <FormGroup>
                      <Label for="kit_id">Código do Kit</Label>
                      <Input
                        disabled
                        id      = "kit_id"
                        name    = "kit_id"
                        style   = {{ background: '#F9F9F9', cursor: 'default' }}
                        type    = "number"
                        value   = {kit_id}
                      />
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='6'>
                    <FormGroup>
                      <Label for="kit_nome">Nome</Label>
                      <Input
                        id            = "kit_nome"
                        name          = "kit_nome"
                        defaultValue  = {form.kit_nome}
                        onChange      = {onChange('kit_nome')}
                        maxLength     = {50}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup>
                      <Label for="kit_saldo">Saldo</Label>
                      <Input
                        id        = "kit_saldo"
                        name      = "kit_saldo"
                        type      = "number"
                        min       = "0"
                        value     = {parseInt(form.kit_saldo)}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const newValue = parseInt(inputValue);

                          if (!isNaN(newValue) && newValue <= 999999) {
                            e.target.value = newValue;
                            onChange('kit_saldo')(e);
                          }else if(isNaN(newValue)){
                            e.target.value = 0;
                            onChange('kit_saldo')(e);
                          }
                        }}
                        // onChange  = {onChange('kit_saldo')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='3'>
                    <FormGroup check inline className="mb-0 mt-4">
                      <Label check for="kit_ativo">
                        <Input
                          id              = "kit_ativo"
                          name            = "kit_ativo"
                          type            = "checkbox"
                          defaultChecked  = {form.kit_ativo=='S' ? true : false}
                          onChange        = {onChange('kit_ativo')}
                        />
                        <span className="form-check-sign" />Kit Ativo
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Col className="text-center p-3">
                  <Button type="submit" className="mb-0 mt-0" color="success" size="md" >
                    Salvar
                  </Button>
                  <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
                    Fechar
                  </Button>
                </Col>
              </Form>

            </TabPane>

            <TabPane tabId="2">

              <Col md="12">
                <Row>
                  <Col md="8">
                    <Label for="lojas">Selecione a loja para a visialização dos produtos</Label>
                    <ReactSelect
                      required
                      id          = "lojas"
                      key         = "lojas"
                      name        = "lojas"
                      placeholder = "Selecione a loja"
                      className   = "m-0 w-100"
                      options     = {listaLoja}
                      onChange    = {selectFilial}
                    >
                    </ReactSelect>
                  </Col>

                  <Col md="4" className="d-flex pt-2">
                    <Button
                      block
                      color     = "info"
                      disabled  = {duplicarKitBtn}
                      onClick   = {abreModalDuplicaKit}
                      style={{height: '43px'}}
                    >Replicar lista entre lojas
                    </Button>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Col md="8">
                    <FormGroup>
                      <Label for="produtos">Selecione o produto para inserir no kit</Label>
                      <AsyncSelect
                        cacheOptions
                        id          = "produtos"
                        key         = {`produtos_${filial?.id}`}
                        name        = "produtos"
                        placeholder = "Código de barras ou descrição ..."
                        onChange    = {produtoSelecionado}
                        loadOptions = {pesquisaProdutos}
                        isDisabled  = {camposProduto}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup check inline className="mb-0 mt-4">
                      <Label check for="produtoSaldo">
                        <Input
                          id        = "produtoSaldo"
                          name      = "produtoSaldo"
                          type      = "checkbox"
                          defaultChecked   = {produtoSaldo}
                          onClick   = {clickProdutoSaldo}
                        />
                        <span className="form-check-sign" />Apenas produtos com saldo
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md='2'>
                    <FormGroup>
                      <Label for="quantidade">quantidade no kit</Label>
                      <Input
                        id          = "quantidade"
                        name        = "quantidade"
                        type        = "number"
                        placeholder = "0"
                        min         = "0"
                        value       = {parseInt(formProd.quantidade)}
                        onBlur      = {atualizaValorTotal}
                        disabled    = {camposProduto}
                        // onChange    = {onChangeProd('quantidade')}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          const newValue = parseInt(inputValue);

                          if (!isNaN(newValue) && newValue <= 999999) {
                            e.target.value = newValue;
                            onChangeProd('quantidade')(e);
                          }else if(isNaN(newValue)){
                            e.target.value = 0;
                            onChangeProd('quantidade')(e);
                          }
                        }}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="valor">Valor unitário</Label>
                      <NumberFormat
                        required
                        fixedDecimalScale
                        id                = "valor"
                        name              = "valor"
                        placeholder       = "0,00"
                        maxLength         = {15}
                        decimalScale      = {2}
                        allowNegative     = {false}
                        className         = {"form-control"}
                        prefix            = {"R$ "}
                        decimalSeparator  = {','}
                        value             = {formProd.valor}
                        onBlur            = {atualizaValorTotal}
                        disabled          = {camposProduto}
                        onChange          = {onChangeProd('valor')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="desconto">Desconto</Label>
                      <NumberFormat
                        required
                        fixedDecimalScale
                        id                = "desconto"
                        name              = "desconto"
                        className         = {"form-control"}
                        placeholder       = "0.00"
                        maxLength         = {9}
                        decimalScale      = {2}
                        allowNegative     = {false}
                        suffix            = {' %'}
                        decimalSeparator  = {'.'}
                        value             = {formProd.desconto}
                        onChange          = {onChangeProd('desconto')}
                        onBlur            = {atualizaValorTotal}
                        onValueChange     = {atualizaValorTotal}
                        disabled          = {camposProduto}
                      />
                    </FormGroup>
                  </Col>

                  <Col md='2'>
                    <FormGroup>
                      <Label for="total">Total</Label>
                      <NumberFormat
                        required
                        fixedDecimalScale
                        disabled
                        id                = "total"
                        name              = "total"
                        className         = {"form-control"}
                        placeholder       = "0,00"
                        maxLength         = {20}
                        decimalScale      = {2}
                        allowNegative     = {false}
                        prefix            = {"R$ "}
                        decimalSeparator  = {','}
                        value             = {formProd.total}
                        onChange          = {onChangeProd('total')}
                      />
                    </FormGroup>
                  </Col>

                  <Col md="4" className="d-flex pt-2">
                    <Button
                      block
                      color     = "warning"
                      disabled  = {camposProduto}
                      onClick   = {inserirProduto}
                    >INSERIR PRODUTO</Button>
                  </Col>
                </Row>

                {
                  loadingListProd ?
                    <Loading tipo='componente'/>
                  :
                    <>
                    <BootstrapTable
                      striped
                      keyField          = 'produto_id'
                      data              = {listaProdutosKit}
                      columns           = {colunas}
                      noDataIndication  = "Nenhum registro encontrado"
                      cellEdit          = {
                                            cellEditFactory({
                                              blurToSave: true,
                                              mode: 'dbclick',
                                              autoSelectText: true,
                                              beforeSaveCell
                                            })
                                          }
                    />
                    <Col>
                      <footer className="blockquote-footer text-right text-danger">Total do Kit <cite title="Source Title">{valorProdutosKit}</cite></footer>
                    </Col>
                    </>
                }
              </Col>

              <Col className="text-center p-3">
                <Button type="button" className="mb-0 mt-0" color="default" size="md" onClick={() => fechaModal()}>
                  Fechar
                </Button>
              </Col>
            </TabPane>
          </TabContent>

        </ModalBody>
      </FormGroup>

      <Modal
        key     = 'modaDuplicaKit'
        size    = 'md'
        isOpen  = {modalDuplicaKit}
      >
        <ModalHeader>Replicar lista de produtos entre as lojas</ModalHeader>
        <DuplicaKit
          listaProdutos = {listaProdutosKit}
          fechaModal    = {fechaModalDuplicaKit}
        >
        </DuplicaKit>
      </Modal>

    </>
  )
}

export default FormKit;